const dataFilterAZ = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.92 12.64v-9.4"/><polyline points="1.42 5.78 3.94 2.64 6.42 5.72"/><text stroke-width="0" font-family="Roboto-Regular, Roboto" font-size="7"><tspan x="9" y="7">A</tspan></text><text stroke-width="0" font-family="Roboto-Regular, Roboto" font-size="7"><tspan x="9" y="13">Z</tspan></text></svg>',
};

export { dataFilterAZ as default };
